import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const goBack = () => navigate("/");

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <article className="min-h-screen px-6 py-24 bg-linear-to-br from-amber-100 via-orange-100 to-red-100 text-orange-900 flex flex-col items-center justify-center text-center">
      <div className="mb-6">
        <svg
          className="w-24 h-24 mx-auto text-orange-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h1 className="mb-4 text-5xl font-semibold tracking-[0.4rem] uppercase text-orange-700">
        Unauthorized
      </h1>
      <p className="mb-8 max-w-md text-lg leading-relaxed text-orange-800/90">
        You do not have access to the requested page. This may be because you
        are not connected to an organization or lack the required permissions.
      </p>
      <div className="flex flex-col gap-4 items-center">
        <div className="flex gap-4">
          <button
            onClick={goBack}
            className="inline-flex items-center justify-center rounded-full bg-orange-500 px-7 py-3 font-semibold text-white shadow-lg transition duration-200 hover:-translate-y-0.5 hover:bg-orange-600 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400"
          >
            Go Back
          </button>
        </div>
        <p className="text-sm text-orange-700/80">
          Still having trouble?{" "}
          <button
            type="button"
            onClick={handleLogout}
            className="underline font-medium hover:text-orange-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 rounded"
          >
            Log out and sign in again
          </button>
        </p>
      </div>
    </article>
  );
};

export default Unauthorized;
